export abstract class HttpError {
  constructor(public text?: string) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/error/http-error.ts